(() => {
  const config = window.YnsPasswordWaitlist;
  const root = document.querySelector('.yns-pw');
  if (!config || !root || root.dataset.ready === '1') return;
  root.dataset.ready = '1';

  const steps = [...root.querySelectorAll('.yns-pw__step')];
  const dots = [...root.querySelectorAll('.yns-pw__dots i')];
  const progress = root.querySelector('#YnsPwProgress');
  const postal = root.querySelector('#YnsPwPostal');
  const email = root.querySelector('#YnsPwEmail');
  const consent = root.querySelector('#YnsPwConsent');
  const submit = root.querySelector('[type="submit"]');
  let concern = '';
  let water = null;

  const showStep = (number) => {
    steps.forEach((step) => step.classList.toggle('is-active', Number(step.dataset.step) === number));
    dots.forEach((dot, index) => dot.classList.toggle('is-active', index === Math.min(number - 1, 2)));
    progress.textContent = number <= 3 ? `Étape ${number} sur 3` : 'Terminé';
  };

  root.querySelector('#YnsPwCheck').addEventListener('click', async () => {
    const value = postal.value.trim();
    const error = root.querySelector('#YnsPwPostalError');
    if (!/^\d{5}$/.test(value)) {
      error.textContent = 'Saisissez un code postal français à 5 chiffres.';
      return;
    }
    error.textContent = '';
    try {
      const response = await fetch(config.waterUrl);
      if (!response.ok) throw new Error('water-data');
      const data = await response.json();
      water = data[value] || null;
      root.querySelector('#YnsPwAvailable').classList.add('is-visible');
      window.setTimeout(() => showStep(2), 420);
    } catch (_error) {
      error.textContent = 'Le relevé est momentanément indisponible. Réessayez dans un instant.';
    }
  });

  root.querySelectorAll('.yns-pw__choice').forEach((button) => button.addEventListener('click', () => {
    root.querySelectorAll('.yns-pw__choice').forEach((item) => {
      item.classList.remove('is-selected');
      item.setAttribute('aria-checked', 'false');
    });
    button.classList.add('is-selected');
    button.setAttribute('aria-checked', 'true');
    concern = button.dataset.concern;
    root.querySelector('#YnsPwChoiceError').textContent = '';
  }));

  root.querySelector('#YnsPwToEmail').addEventListener('click', () => {
    if (!concern) {
      root.querySelector('#YnsPwChoiceError').textContent = 'Choisissez la situation qui vous ressemble le plus.';
      return;
    }
    showStep(3);
    window.setTimeout(() => email.focus(), 80);
  });

  root.querySelector('#YnsPasswordQuiz').addEventListener('submit', async (event) => {
    event.preventDefault();
    const error = root.querySelector('#YnsPwEmailError');
    const address = email.value.trim();
    if (!email.validity.valid || !address) {
      error.textContent = 'Saisissez une adresse email valide.';
      email.focus();
      return;
    }
    if (!consent.checked) {
      error.textContent = 'Confirmez l’envoi de votre analyse et de votre accès.';
      consent.focus();
      return;
    }

    error.textContent = '';
    submit.disabled = true;
    submit.textContent = 'Envoi en cours…';
    const codePostal = postal.value.trim();
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'password',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: address,
                location: { zip: codePostal, country: 'FR' },
                properties: {
                  code_postal: codePostal,
                  preoccupation: concern,
                  commune_affichee: water?.c || null,
                  durete_affichee: water?.th == null ? null : `${String(water.th).replace('.', ',')} °f`,
                  durete_of: water?.th ?? null,
                  chlore_libre_mgl: water?.chl ?? null,
                  nitrates_mgl: water?.no3 ?? null,
                  pesticides_ugl: water?.pest ?? null,
                  date_prelevement: water?.thd || water?.chld || water?.no3d || water?.pestd || null
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: config.klaviyoListId } } }
      }
    };

    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(config.klaviyoCompanyId)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error(`Klaviyo ${response.status}`);
      showStep(4);
    } catch (_failure) {
      error.textContent = 'L’envoi n’a pas abouti. Vérifiez votre connexion puis réessayez.';
      submit.disabled = false;
      submit.textContent = 'Recevoir mon analyse et mon accès';
    }
  });
})();
